import { render, staticRenderFns } from "./VisitorSubmitResult.vue?vue&type=template&id=2c73b7b2&scoped=true"
import script from "./VisitorSubmitResult.vue?vue&type=script&lang=js"
export * from "./VisitorSubmitResult.vue?vue&type=script&lang=js"
import style0 from "./VisitorSubmitResult.vue?vue&type=style&index=0&id=2c73b7b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c73b7b2",
  null
  
)

export default component.exports